import { Stack, useNavigation, usePathname } from "expo-router"
import { BFDetailsScreen } from "@/components/standard/screen/BFDetailsScreen"
import { getFocusedRouteNameFromRoute, useRoute } from "@react-navigation/core"
import { useLayoutEffect } from "react"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { TAB_BAR_HEIGHT } from "@/app/(tabs)/_layout"
import PropertiesScreen from "@/screens/analyze/PropertiesScreen"

const TABS_HIDDEN_ROUTES = ["[analysisId]/comp/[compId]", "[analysisId]/map"]

export default () => {
  const path = usePathname()
  const hideDetails = path === "/properties"
  const { bottom } = useSafeAreaInsets()

  const navigation = useNavigation()
  const route = useRoute()

  useLayoutEffect(() => {
    const routeName = getFocusedRouteNameFromRoute(route) || "index"

    if (TABS_HIDDEN_ROUTES.includes(routeName)) {
      navigation.setOptions({ tabBarStyle: { display: "none" } })
    } else {
      navigation.setOptions({
        tabBarStyle: { display: "flex", height: TAB_BAR_HEIGHT + bottom },
      })
    }
  }, [navigation, route])

  return (
    <BFDetailsScreen
      hideDetails={hideDetails}
      mainScreen={<PropertiesScreen />}
      details={
        <Stack screenOptions={{ headerShown: false }}>
          <Stack.Screen name="index" options={{ headerShown: false }} />
          <Stack.Screen
            name="[analysisId]/index"
            options={{
              headerShown: false,
              animation: "none",
            }}
          />
          <Stack.Screen
            name="[analysisId]/map"
            options={{
              headerShown: false,
              animation: "slide_from_bottom",
              presentation: "fullScreenModal",
            }}
          />
          <Stack.Screen
            name="[analysisId]/street"
            options={{ headerShown: false, presentation: "fullScreenModal" }}
          />
          <Stack.Screen
            name="[analysisId]/comp/[compId]"
            options={{
              headerShown: false,
              // presentation: "containedModal",
              animation: "none",
            }}
          />
          <Stack.Screen
            name="[analysisId]/customizecomps"
            options={{ headerShown: false, presentation: "fullScreenModal" }}
          />
        </Stack>
      }
    />
  )
}
